// フォントファミリー
export class FontFamily
{
    // id : 英語表示名のハイフンつなぎ
    public id : string = "";
    // priority : リスト表示時の優先順位(数字が低いほど先に表示する)
    public priority : number = 0;
    // アプリ表示名
    public displayName : string = "";
    // フルネーム : 日本語
    public fullNameJP : string = "";
    // ファミリー名 : 日本語
    public familyNameJP : string = "";
    // フルネーム : 英語
    public fullNameEN : string = "";
    // ファミリー名 : 英語
    public familyNameEN : string = "";
    // 総称ファミリー名 : sans-serif(ゴシック) serif(明朝)
    public genericName : string = "";
    // レンダリングフォント名
    public renderingFontName : string = "";
    // 縦書きレンダリングフォント名
    public renderingFontNameVertical : string = "";
    // ウェイト
    public weight : number | null = null;
    // Italicにできるかどうか
    public canItalic : boolean = false;
    // 日本語代替するか
    public isUseJPFont : boolean = false;
    // 日本語代替フォントId
    public idJP : string = "";

    // ローカルフォントか
    public isLocalFont : boolean = false;
    // 一部のローカルフォントに対して、特別に指定しないといけないフォント名
    public optionalFontName : string = "";

    public toString()
    {
        var str = "";

        if(this.optionalFontName != "")
        {
            str += "'" + this.optionalFontName + "'";
        }
        if(this.fullNameJP != "") 
        { 
            if(str.length > 0) { str += ","; }
            str += "'" + this.fullNameJP + "'";
        }
        if(this.fullNameEN != "") 
        {
            if(str.length > 0) { str += ","; }
            str += "'" + this.fullNameEN + "'";
        }
        if(this.familyNameJP != "")
        {
            if(str.length > 0) { str += ","; }
            str += "'" + this.familyNameJP + "'";
        }
        if(this.familyNameEN != "")
        {
            if(str.length > 0) { str += ","; }
            str += "'" + this.familyNameEN + "'";
        }
        if(this.genericName != "")
        {
            if(str.length > 0) { str += ","; }
            str += this.genericName;
        }

        return str;
    }

    public toStringSimpleText()
    {
        var str = "";

        if(this.optionalFontName != "")
        {
            str += "'" + this.optionalFontName + "'";
        }
        if(this.fullNameJP != "") 
        { 
            if(str.length > 0) { str += ","; }
            str += "'" + this.fullNameJP + "'";
        }
        if(this.fullNameEN != "") 
        {
            if(str.length > 0) { str += ","; }
            str += "'" + this.fullNameEN + "'";
        }
        if(this.familyNameJP != "")
        {
            if(str.length > 0) { str += ","; }
            str += "'" + this.familyNameJP + "'";
        }
        if(this.familyNameEN != "")
        {
            if(str.length > 0) { str += ","; }
            str += "'" + this.familyNameEN + "'";
        }

        return str;
    }
    
    constructor(id : string, 
        priority : number,
        displayName : string, 
        fullNameJP : string,
        fullNameEN : string,
        familyNameJP : string,
        familyNameEN : string,
        genericName : string,
        renderingFontName : string,
        renderingFontNameVertical : string,
        weight : number | null = null,
        canItalic : boolean = false,
        isUseJPFont : boolean = false,
        idJP : string = "",
        )
    {
        this.id = id;
        this.priority = priority;
        this.displayName = displayName;
        this.fullNameJP = fullNameJP;
        this.fullNameEN = fullNameEN;
        this.familyNameJP = familyNameJP;
        this.familyNameEN = familyNameEN;
        this.genericName = genericName;
        this.renderingFontName = renderingFontName;
        this.renderingFontNameVertical = renderingFontNameVertical;
        this.canItalic = canItalic;
        this.weight = weight;
        this.isUseJPFont = isUseJPFont;
        this.idJP = idJP;
    }
}